import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Modal from 'react-modal';
import axios from "axios";
import ProductImage from "./ProductImage";
import { mapToArabic } from "../utils/mapToArabic";
import { FaRegTrashAlt } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";
import { MdClose } from 'react-icons/md';
import { FiCheck } from "react-icons/fi";

const EditOrderModal = ({ order, isOpen, onClose, onSuccess }) => {
  const [items, setItems] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [deletedIds, setDeletedIds] = useState([]);
  const [saving, setSaving] = useState(false);

  const orderId = order?.id;
  const initialQuantities = {};

  useEffect(() => {
    if (order?.items) {
      setItems(order?.items);

      for (const item of order.items) {
        initialQuantities[item.id] = item.quantity;
      }
      setQuantities(initialQuantities);
    }
  }, [order]);

  useEffect(() => {
    if (!isOpen) {
      setItems([]);
      setQuantities({});
      setDeletedIds([]);
    }
  }, [isOpen]);

  const handleIncrease = (id) => {
    setQuantities(prev => ({...prev, [id]: prev[id] + 1}))
  };

  const handleDecrease = (id) => {
    setQuantities(prev => ({...prev, [id]: Math.max(1, prev[id] - 1)}))
  };

  const markForDeletion = (item) => {
    const updatedItems = items.filter(i => i.id !== item.id);

    if (updatedItems.length === 0) {
      return toast.error(<span className="toast">الطلب يجب أن يحتوى على منتج واحد على الأقل</span>);
    }

    setItems(updatedItems);

    setDeletedIds([...deletedIds, item.id]);

    const newQuantities = { ...quantities }
    delete newQuantities[item.id]
    setQuantities(newQuantities);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const newQuantities = [];

      for (const item of items) {
        if (quantities[item.id] !== initialQuantities[item.id]) {
          newQuantities.push({id: item.id, quantity: quantities[item.id]})
        }
      }

      if (newQuantities.length > 0 || deletedIds.length > 0) {
        await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/orders/${orderId}`, { newQuantities, deletedIds }, { withCredentials: true });
        onSuccess();
        toast.success(<span className="toast">تم تعديل الطلب بنجاح</span>);
      }
    } catch (error) {
      toast.error(<span className="toast">حدث خطأ أثناء حفظ التعديلات</span>);
      console.error("Save error:", error);
    } finally {
      setSaving(false);
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={`تعديل طلب رقم ${order?.id}`}
      className="custom-modal"
      overlayClassName="custom-modal-overlay center"
      ariaHideApp={true}
    >
      <div className="space modal-header">
      <p>تعديل الطلب {order?.id}</p>
      <MdClose onClick={onClose} className="close" />
      </div>

      <div className="panelcont" style={{margin: "0 auto"}}>
        {items.length === 0 ? (
          <p>لا يوجد اصناف في هذا الطلب</p>
        ) : (
          items.map((item) => (
          <div key={item.id} className="paneldet">
            <div className="item">
              <ProductImage 
                url={item.image_url}
                alt={item.name}
                loading="lazy"
              />
  
              <div className="details">
                <p className="name">{item.name}</p>
                <span className="brownlabel">{item.width} × {item.height}</span>
                <span className="brownlabel">{mapToArabic(item.material).text}</span>
              </div>

              <div className="actions space">
              <div className="quantity center">
                <button 
                  onClick={() => handleDecrease(item.id)} 
                  disabled={quantities[item.id] <= 1} 
                  className="dec center" 
                  style={{ color: quantities[item.id] <= 1 ? "#cfcece" : "" }}
                >
                  −
                </button>
  
                <span>{quantities[item.id]}</span>
  
                <button 
                  onClick={() => handleIncrease(item.id)} 
                  disabled={quantities[item.id] >= 10} 
                  style={{ color: quantities[item.id] >= 10 ? "#cfcece" : "" }}
                  className="center"
                >
                  +
                </button>
              </div>
  
              <FaRegTrashAlt 
                className="delete cursor" 
                onClick={() => markForDeletion(item)} 
              />
            </div>
            </div>
          </div>
          ))
        )}
      </div>

      {deletedIds.length > 0 && (
        <p className="warn">
          عدد الاصناف التى سيتم حذفها {deletedIds.length}
        </p>
      )}

      <button
        onClick={handleSave}
        disabled={saving}
        className="buttonNoBorder greenlabel"
      >
        {saving ? <ImSpinner2 className="smallspinner" /> :
          <FiCheck className="checkmark" />
        } حفظ
      </button>
    </Modal>
  );
};

export default EditOrderModal;
